import {
	GetCommissionCashbackRequest,
	GetCommissionCashbackResponse,
} from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getCommissionCashbackList } from '../../services'
import { CommissionCashbackQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetCommission(
	payload: GetCommissionCashbackRequest,
	props?: UseBaseQueryOptions<GetCommissionCashbackResponse>,
) {
	return useQuery({
		queryKey: [CommissionCashbackQueryKeys.GetCommissionCashbackList, payload],
		queryFn: () => getCommissionCashbackList(payload),
		...props,
	})
}
